<div class="sidebar included">
	<app-sidebar-header [title]="'priceBreakdown.title.priceBreakdown' | ibeadmin | async"></app-sidebar-header>

	<div class="sidebar__body sl--scrollable" #sidebar__body>

		<!-- Extras -->
		<ng-container>
			<div class="price-breakdown-list">
				<div class="price-breakdown-list--title">{{ 'priceBreakdown.title.extras' | ibeadmin | async }}</div>
				<ul class="body">
					<li class="extras-feature extras-feature__price-breakdown">
						<app-svg title="Icon" class="ancillary-icon" svg="icons.svg#tickets--time_to_think"
							[alt]="'priceBreakdown.alt.timeToThinkIncon' | ibeadmin | async"></app-svg>
						<span class="extras-feature__label">{{ 'priceBreakdown.title.timeToThink' | ibeadmin | async }}</span>
						<span class="price">{{timeToThink.totalFee + currency | indracurrency}}</span>
					</li>
				</ul>
			</div>

			<div class="price-breakdown-count price-breakdown-count--total payment-table">
				<div class="price-breakdown-label payment-table__line">
					<div class="price-breakdown-title">
						{{ 'priceBreakdown.title.total' | ibeadmin | async }}
					</div>
					<div class="price bold">
						{{timeToThink.totalFee + currency | indracurrency}}
					</div>
				</div>
			</div>
		</ng-container>
		<!-- End Extras -->

	</div>

	<div class="sidebar-flight-extras">
		<ul class="body">
			<li class="extras-feature">
				<div class="extras-feature__label">
					<h3>{{ 'priceBreakdown.text.totalAmountPayNow' | ibeadmin | async }}</h3>
				</div>
				<p>{{timeToThink.totalFee + currency | indracurrency}}</p>
			</li>
		</ul>
	</div>

	<div #sidebar__footer class="sidebar__footer ">
	</div>
</div>
